import axios from "@/index";
const inquiryCode = {
  state: {
    inquiryCodeList: [],
    inquiryCodeData: []
  },
  getters: {},
  actions: {
    getInquiryCodeList: ({ commit, state, dispatch }, config = {}) => {
      return new Promise((resolve, reject) => {
        axios
          .get(config.url, config.params)
          .then(response => {
            if (response.status === 200) {
              commit(
                "setInquiryCodeList",
                (state, { inquiryCodeList: response.data })
              );
              resolve(response.data);
            } else {
              reject("error");
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    getInquiryCodeInfo: ({ commit, state, dispatch }, config = {}) => {
      return new Promise((resolve, reject) => {
        axios
          .get(config.url, config.params)
          .then(response => {
            if (response.status === 200) {
              commit("setInquiryCodeInfo", state, {
                inquiryCodeData: response.data
              });
              resolve(response.data);
            } else {
              reject("error");
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  mutations: {
    setInquiryCodeList(state, action) {
      state.inquiryCodeList = action.inquiryCodeList;
    },
    setInquiryCodeInfo(state, action) {
      state.inquiryCodeData = action.inquiryCodeData;
    }
  }
};
export default inquiryCode;
